export const DIGITS = new Set([0, 8, 9].concat("0123456789".split("").map(c => c.charCodeAt(0))));

export const acceptKeys = allowed => event => allowed.has(event.which) || event.preventDefault();
